/** Builds the Authorization header from the stored JWT token. */
export const AUTH_HEADER = (): Record<string, string> => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

/**  * MUI `sx` styles applied to every <Box> that renders user-authored rich HTML */
export const richHtmlSx = {
  border: '1px solid rgba(0,0,0,0.23)',
  borderRadius: 1,
  p: 2,
  backgroundColor: '#f9f9f9',
  overflowX: 'auto',
  overflowY: 'auto',
  '& table': { borderCollapse: 'collapse', width: '100%', fontSize: '0.875rem', marginBottom: '8px' },
  '& th, & td': { border: '1px solid rgba(0,0,0,0.2)', padding: '6px 12px', textAlign: 'left', verticalAlign: 'top' },
  '& th': { backgroundColor: 'rgba(0,0,0,0.04)', fontWeight: 600 },
  '& tr:nth-of-type(even)': { backgroundColor: 'rgba(0,0,0,0.02)' },
  '& img': { maxWidth: '100%', height: 'auto' },
  '& p': { marginTop: 0, marginBottom: '8px' },
  '& ul, & ol': { paddingLeft: '20px', marginTop: 0, marginBottom: '8px' },
} as const;

export const STATUS_COLORS: Record<
  string,
  'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
> = {
  assigned: 'default',
  accepted: 'info',
  in_progress: 'primary',
  under_evaluation: 'warning',
  evaluated: 'secondary',
  completed: 'success',
};
